import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Papa from 'papaparse';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Button, DeleteConfirmation, Loader, NoTopic } from '../shared-components';
import { updateTopicDropdownOnAddTopic } from '../home/redux/updateTopicDropDown';
import {retrieveTopicsDropdown} from '../home/redux/retrieveTopicsDropdown';
import CreateTopicModalManager from './components/CreateTopicModalManager';
import { toast } from 'react-toastify';
import {DebounceInput} from 'react-debounce-input';
import { GaContext } from '../../googleAnalyticsContext/GaContext';
import { convertEstimationTimeStringFromHours, getLoginRedirectUrl } from '../home/sharedFunctions';
import {
  TOPIC_PROCESSED_STATE_READY,
  DEFAULT_RETRIEVE_TOPICS_PAGE_ID,
  DEFAULT_RETRIEVE_TOPICS_RETRIEVE_LIMIT, BOOLEAN_OR, BOOLEAN_NOT, BOOLEAN_AND,
  ADD_NEW_UPLOAD_DATA_TOPIC_ACTION_TYPE,
  ADD_NEW_KEYWORD_TOPIC_ACTION_TYPE,
  REACT_GA_TOPIC_CATEGORY,
  KEY_FOR_TOPIC_ID,
  KEY_FOR_FILE_DATE_UPLOADED,
  KEY_FOR_DATE_FOR_COMMENTS,
  KEY_FOR_UPLOADED_FILE,
  KEY_FOR_COUNT,
  KEY_FOR_FILE_LANGUAGE,
  DEFAULT_PROCESSED_STATUS
} from './redux/constants';
import {
  CHOOSE_DATA_SOURCE_TOPIC_MODAL_STATE,
  UPLOAD_FILES_MODAL_STATE,
  LOADING_MODAL_STATE,  
  DATA_SUMMARY_WITH_ERRORS_MODAL_STATE,
  DATA_SUMMARY_MODAL_STATE,
  REMOVE_ROWS_WITH_ERRORS_CONFIRMATION_STATE,
  EDIT_TOPIC_MODAL_STATE,
  LOCAL_STORAGE_KEY_FOR_DO_NOT_SHOW_REMOVE_ROWS_CONFIRMATION,
  CONTENT_KEY,
  DATE_KEY,
  SOURCE_KEY,
  SOURCE_LINK_KEY,
  UPLOAD_FILE_IN_CSV_FORMAT,
  MODAL_STATES_REQUIRING_CANCEL_CONFIRMATION,
  CONFIRM_CANCEL_TOPIC_CREATION_STATE,
  EDIT_TOPIC_TYPE_TAG
} from './components/constants/constants';
import { t } from 'i18next';
import { TOPICS_I18N_KEYS as MY_I18N_KEYS, TOPICS_I18N_PREFIX as MY_I18N_PREFIX } from './constants/i18n/Topicsi18nConstants';
import moment from 'moment';
import { DATE_TIME_IN_YYYY_MM_DD_HH_MM_SS_FORMAT } from '../../features/shared-components/chart/constants/eventLabellingChartConstants';
import { apiEndPoints } from '../../common/globalConstants';
import http from '../../common/http';

export class Topics extends Component {
  static propTypes = {
    topics: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    cookies: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };
  state = {
    currentPage: DEFAULT_RETRIEVE_TOPICS_PAGE_ID,
    totalPage: 1,
    currentPageStartIndex: 0,
    currentPageEndIndex: 0,
    filterText: "",
    isAddTopic: false,
    pageLimit: 10,
    retrieveLimit: DEFAULT_RETRIEVE_TOPICS_RETRIEVE_LIMIT,
    editTopicData: {},
    newUploadDataTopicData: {}, 
    addTopicActionType: ADD_NEW_KEYWORD_TOPIC_ACTION_TYPE,
    confirmDeleteModal: false,
    topicToDelete: null,
    allTopicsData: [],
    allTopicNames: [],
    filteredTopicsData: [],
    paginatedAndFilteredTopicsData: [],
    updatedTopicData: {},
    allCategories: [],
    modalState: '',
    previousModalState: "",
    uploadedFileName: "",
    fileInfoAfterValidation: null,
    totalDataPointsForUploadedFile: null,
    fileUploadDateTime: "",
    fileValidationErrors: [],
    cleanedFileData: null,
    userInputDateForUploadedComments: null,
    userInputLanguageForUploadedComments: null,
    hasConfirmedFileForUploadedTopic: false,
    allUploadedData: [],
    allUploadedFilesForTopic: {},
    uploadedFileBeingPostedToBackend: null
  };

  getI18nText(key,params) {
    return t(MY_I18N_PREFIX + "." + key,params);
  }

  showAddTopic = () => {
    window.history.replaceState(this.state,'','/dashboard/topics/addTopic')
    this.setState(
      {
        modalState: CHOOSE_DATA_SOURCE_TOPIC_MODAL_STATE
      },
      () =>
        this.setState({
          isAddTopic: true,
        }),
    );
    this.props.actions.resetTopicState();
  };

  editTopic = topic => {
    window.history.replaceState(this.state,'','/dashboard/topics/editTopic')
    this.setState(
      {
        addTopicActionType: EDIT_TOPIC_TYPE_TAG,
        editTopicData: topic
      }
    );
    this.props.actions.resetTopicState();
    this.props.actions.retrieveAllUploadedFilesForTopic(topic);
  };

  addEditModalAction = topicData => {
    const { createTopics, updateTopics } = this.props.actions;
    const { addTopicActionType, editTopicData } = this.state;
    if (addTopicActionType === ADD_NEW_KEYWORD_TOPIC_ACTION_TYPE) {
      createTopics(topicData);
      this.setState({ updatedTopicData: topicData });
      this.context.ReactGA.event({
        category: REACT_GA_TOPIC_CATEGORY,
        action: 'Added a new topic_name='+topicData.topicName+' by user with id '+this.props.cookies.cookies.userMeta
      });
    } 
    else if (addTopicActionType === ADD_NEW_UPLOAD_DATA_TOPIC_ACTION_TYPE) {
      createTopics(topicData);
      this.setState({ newUploadDataTopicData: topicData });
      this.context.ReactGA.event({
        category: REACT_GA_TOPIC_CATEGORY,
        action: 'Added a new upload data topic_name='+topicData.topicName+' by user with id '+this.props.cookies.cookies.userMeta
      });
    }
    else {
      const updatedTopics = Object.assign({}, topicData, { topicId: editTopicData.topicId });
      this.setState({ updatedTopicData: updatedTopics, editTopicData: topicData });

      updateTopics(updatedTopics);
      this.context.ReactGA.event({
        category: REACT_GA_TOPIC_CATEGORY,
        action: 'a topic was edited topic_name='+topicData.topicName+' by user with id '+this.props.cookies.cookies.userMeta
      });
    }
  };

  retrieveTopicPreviewAction = topicData => {
    const { retrieveTopicPreview } = this.props.actions;

    retrieveTopicPreview(topicData);
    this.context.ReactGA.event({
      category: REACT_GA_TOPIC_CATEGORY,
      action: 'Topic preview for topic keywords JSON='+ JSON.stringify(topicData.keywordsJSON) +' and category "' + topicData.categories + '" by user with id '+this.props.cookies.cookies.userMeta
    });
  }

  removeTopic = topic => {
    this.setState({ confirmDeleteModal: true, topicToDelete: topic });
  };

  toggleModal = (e) => {
    if (
      MODAL_STATES_REQUIRING_CANCEL_CONFIRMATION.includes(this.state.modalState) && 
      this.state.allUploadedData.length === 0 &&
      this.state.addTopicActionType != EDIT_TOPIC_TYPE_TAG
    ) {
      this.handleCancelTopicCreationConfirmationModal();
    } else {
      window.history.replaceState(this.state,'','/dashboard/topics')
      this.setState({
        isAddTopic: e,
        uploadedFileName: "",
        fileInfoAfterValidation: null,
        fileValidationErrors: [],
        cleanedFileData: null,
        totalDataPointsForUploadedFile: null,
        fileUploadDateTime: "",
        userInputDateForUploadedComments: null,
        userInputLanguageForUploadedComments: null,
        allUploadedData: [],
        allUploadedFilesForTopic: {}
      });
    }
  };

  deleteTopic = () => {
    window.history.replaceState(this.state,'','/dashboard/topics/deleteTopic')
    const { deleteTopic } = this.props.actions;
    const { topicToDelete } = this.state;
    this.context.ReactGA.event({
      category: REACT_GA_TOPIC_CATEGORY,
      action: 'topic='+topicToDelete.topicName +' was deleted' + ' by user with id'+this.props.cookies.cookies.userMeta
    });
    deleteTopic(topicToDelete);
  };

  handlePagination = pageChangeType => {
    const {
      currentPage,
      totalPage,
      pageLimit,
      filteredTopicsData
    } = this.state;
    let newPageNumber = null;
    switch (pageChangeType) {
      case 'next':
        if (currentPage < totalPage) {
          newPageNumber = currentPage + 1;
        }
        break;
      case 'prev':
        if (currentPage > 1) {
          newPageNumber = currentPage - 1;
        }
        break;
      case 'reset':
        newPageNumber = 1;
      case 'same':
        if (currentPage > totalPage) {
          newPageNumber = totalPage;
        }
        else {
          newPageNumber = currentPage;
        }
      default:
        break;
    }

    if (newPageNumber != null) {
      const currentPageStartIndex = (pageLimit*(newPageNumber-1));
      const currentPageEndIndex   = (pageLimit*newPageNumber);
      const paginatedAndFilteredTopicsData = filteredTopicsData.slice(currentPageStartIndex,currentPageEndIndex);
      this.setState({
        currentPage: newPageNumber,
        currentPageStartIndex: currentPageStartIndex,
        currentPageEndIndex: currentPageEndIndex,
        paginatedAndFilteredTopicsData: paginatedAndFilteredTopicsData
      });
    }
  };

  PaginationControl = () => {
    const { currentPage, totalPage } = this.state;
    const { allTopics } = this.props.topics;

    return (
      <React.Fragment>
        <div className="total-count">
          <label>
            <strong>{isNaN(allTopics[KEY_FOR_COUNT]) ? '': allTopics[KEY_FOR_COUNT]}</strong> {this.getI18nText(MY_I18N_KEYS.topics)}
          </label>
        </div>
        <div className="pagination-controls">
          <span className="prev" onClick={() => this.handlePagination('prev')}></span>
          <label>
            Page{' '}
            <strong>
              {currentPage} of {totalPage}
            </strong>
          </label>
          <span className="next" onClick={() => this.handlePagination('next')}></span>
        </div>
      </React.Fragment>
    );
  };

  componentWillUnmount() {
    this.props.actions.resetTopicState();
  }

  static contextType =GaContext
  componentDidMount() {

    const {ReactGA} = this.context;
    ReactGA.pageview('/dashboard/topics');

    const checkAuthTokenRequest = http.get(apiEndPoints.authentication.CHECK_TOKEN);
    checkAuthTokenRequest.then(
      response => {
        const { retrieveTopics, retrieveCategories } = this.props.actions;
        const { currentPage, retrieveLimit } = this.state;
        retrieveTopics({ pageId: currentPage, pageLimit: retrieveLimit});
        retrieveCategories();
      },
      error => {
        this.props.history.push(getLoginRedirectUrl());
        return false;
      },
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.topics.allTopics.data && nextProps.topics.allTopics.data.length) {
      this.setState({
        allTopicsData: nextProps.topics.allTopics.data
      }, () => {
        const { filterText } = this.state;
        this._filterTopics({filterText: filterText, keepCurrentPage: true});
        this._setAllTopicNamesToState(nextProps.topics.allTopics.data);
      });
    }

    this._handlePropsForCreatedTopicIfNeeded(nextProps);
    this._handlePropsForUpdatedTopicIfNeeded(nextProps);
    this._handlePropsForDeletedTopicIfNeeded(nextProps);
    this._handlePropsForTopicCreationFailure(nextProps);
    this._handlePropsForUploadFileSuccess(nextProps);
    this._handlePropsForUploadFileFailure(nextProps);
    this._handlePropsForRetrieveAllUploadedFilesForTopicSuccess(nextProps);
    this._handlePropsForRetrieveAllUploadedFilesForTopicFailure(nextProps);

    if (
      nextProps.topics.retrieveCategoriesSuccess &&
      JSON.stringify(nextProps.topics.allCategories) !== JSON.stringify(this.state.allCategories)
    ) {
      this.setState({
        allCategories: nextProps.topics.allCategories,
      });
    }
  }

  _setAllTopicNamesToState(topics) {
    const allTopicNames = topics.map(function(topic){
      return topic.topicName;
    })
    this.setState({allTopicNames: allTopicNames});
  }

  _handlePropsForCreatedTopicIfNeeded(nextProps) {
    const { addTopicActionType } = this.state;
    if (nextProps.topics.createTopicsSuccess && Object.keys(this.state.updatedTopicData).length && addTopicActionType === ADD_NEW_KEYWORD_TOPIC_ACTION_TYPE) {
      this._handlePropsForCreatedKeywordFilteringTopic();
    }
    else if (nextProps.topics.createTopicsSuccess && addTopicActionType === ADD_NEW_UPLOAD_DATA_TOPIC_ACTION_TYPE) {
      this._handlePropsForCreatedUploadDataTopic(nextProps);
    }
  }

  _handlePropsForCreatedKeywordFilteringTopic() {
    const topicPreviewEstimatedProcessingTimeInHours = this.props.topics.topicPreviewEstimatedProcessingTimeInHours;
    if (topicPreviewEstimatedProcessingTimeInHours == null) {
      toast.success(this.getI18nText(MY_I18N_KEYS.topic_successfully_created_within_48_hours_toast_msg));
      
    }else {
      const [numberOfDays, numberOfHours, numberOfMinutes] = convertEstimationTimeStringFromHours(topicPreviewEstimatedProcessingTimeInHours);
      const params = {numberOfDays:numberOfDays, numberOfHours:numberOfHours, numberOfMinutes:numberOfMinutes};
      toast.success(this.getI18nText(MY_I18N_KEYS.topic_successfully_created_within_estimated_time_toast_msg,params));
    }
    this.setState({ isAddTopic: false, updatedTopicData: {}  }, () => {
      this.props.actions.retrieveTopics({ pageId: 1, pageLimit: this.state.retrieveLimit });
    });
  }

  _handlePropsForCreatedUploadDataTopic(nextProps) {
    let { newUploadDataTopicData } = this.state;
    let createdTopicId = nextProps.topics.createdTopicId;
    newUploadDataTopicData.topicId = createdTopicId;
    this.setState(
      {
        newUploadDataTopicData
      },
      () =>
        this.setState({
          modalState: UPLOAD_FILES_MODAL_STATE
        }),
    );
  }

  _handlePropsForUpdatedTopicIfNeeded(nextProps) {
    if (nextProps.topics.updateTopicsSuccess && Object.keys(this.state.updatedTopicData).length) {
      if (nextProps.topics.updateTopicsTopicProcessedState != TOPIC_PROCESSED_STATE_READY) {
        const topicPreviewEstimatedProcessingTimeInHours = this.props.topics.topicPreviewEstimatedProcessingTimeInHours;
        if (topicPreviewEstimatedProcessingTimeInHours == null) {
          toast.success(this.getI18nText(MY_I18N_KEYS.topic_successfully_updated_within_48_hours_toast_msg));
        }else {
          const [numberOfDays, numberOfHours, numberOfMinutes] = convertEstimationTimeStringFromHours(topicPreviewEstimatedProcessingTimeInHours);
          const params = {numberOfDays:numberOfDays, numberOfHours:numberOfHours, numberOfMinutes:numberOfMinutes};
          toast.success(this.getI18nText(MY_I18N_KEYS.topic_successfully_updated_within_estimated_time_toast_msg,params));
        }
      }
      else {
        toast.success(this.getI18nText(MY_I18N_KEYS.topic_successfully_edited_with_no_processed_needed_toast_msg));
      }
      this.setState({  isAddTopic: false, updatedTopicData: {}  }, () => {
        this.props.actions.retrieveTopicsDropdown();
        this.props.actions.retrieveTopics({ pageId: 1, pageLimit: this.state.retrieveLimit });
      });
    }
  }

  _handlePropsForDeletedTopicIfNeeded(nextProps) {
    if (nextProps.topics.deleteTopicSuccess && this.state.topicToDelete != null) {
      toast.success(this.getI18nText(MY_I18N_KEYS.topic_successfully_deleted_toast_msg));

      this.setState({ confirmDeleteModal: false, topicToDelete: null, allUploadedData: [] }, () => {
        this.props.actions.retrieveTopicsDropdown();
        this.props.actions.retrieveTopics({ pageId: 1, pageLimit: this.state.retrieveLimit });
      });
    }

    if (nextProps.topics.deleteTopicFailure && this.state.topicToDelete != null) {
      toast.error(this.getI18nText(MY_I18N_KEYS.failed_to_delete_topic_msg));
      this.setState({ confirmDeleteModal: false, topicToDelete: null, allUploadedData: [] });
    }
  }

  _handlePropsForTopicCreationFailure(nextProps) {
    if (nextProps.topics.createTopicsFailure) {
      toast.error(this.getI18nText(MY_I18N_KEYS.topic_creation_failure_toast_msg));
    }
  }

  _handlePropsForUploadFileSuccess(nextProps) {
    if (nextProps.topics.uploadFileSuccess) {
      const { uploadedFileBeingPostedToBackend, addTopicActionType } = this.state;
      let successfullyUploadedFile = JSON.parse(JSON.stringify(uploadedFileBeingPostedToBackend));
      if (addTopicActionType === ADD_NEW_UPLOAD_DATA_TOPIC_ACTION_TYPE) {
        this._addSuccessfullyPostedFileDetailsToAllUploadedFilesIfCreatingNewTopic(successfullyUploadedFile);
      }
      else {
        this._addSuccessfullyPostedFileDetailsToAllUploadedFilesForTopicIfEditingTopic(successfullyUploadedFile);
      }
      let nextModalState = this._determineNextModalToProceedToAfterFileUploadSuccess(addTopicActionType);
      this.setState(
        {
          modalState: nextModalState
        },
        () =>
          this.setState({
            uploadedFileName: "",
            fileInfoAfterValidation: null,
            fileValidationErrors: [],
            cleanedFileData: null,
            totalDataPointsForUploadedFile: null,
            fileUploadDateTime: "",
            userInputDateForUploadedComments: null,
            userInputLanguageForUploadedComments: null,
            uploadedFileBeingPostedToBackend: null
          }),
      );
      toast.success(this.getI18nText(MY_I18N_KEYS.file_successfully_submitted_toast_msg));
    }
  }

  _addSuccessfullyPostedFileDetailsToAllUploadedFilesIfCreatingNewTopic(successfullyUploadedFile) {
    const { allUploadedData } = this.state;
    let updatedAllUploadedData = allUploadedData.concat(successfullyUploadedFile);
    this.setState({
      allUploadedData: updatedAllUploadedData
    });
  }

  _addSuccessfullyPostedFileDetailsToAllUploadedFilesForTopicIfEditingTopic(successfullyUploadedFile) {
    const { allUploadedFilesForTopic } = this.state;
    let updatedAllUploadedFilesForTopic = JSON.parse(JSON.stringify(allUploadedFilesForTopic));
    updatedAllUploadedFilesForTopic.data.push(successfullyUploadedFile);
    updatedAllUploadedFilesForTopic.count += 1;
    this.setState({
      allUploadedFilesForTopic: updatedAllUploadedFilesForTopic
    });
  }

  _determineNextModalToProceedToAfterFileUploadSuccess(addTopicActionType) {
    if (addTopicActionType === ADD_NEW_UPLOAD_DATA_TOPIC_ACTION_TYPE) {
      return UPLOAD_FILES_MODAL_STATE;
    }
    else {
      return EDIT_TOPIC_MODAL_STATE;
    }
  }

  

  _handlePropsForUploadFileFailure(nextProps) {
    if (nextProps.topics.uploadFileFailure) { 
      toast.error(this.getI18nText(MY_I18N_KEYS.file_submit_failed_toast_msg));
    }
  }

  _handlePropsForRetrieveAllUploadedFilesForTopicSuccess(nextProps) {
    if (
      nextProps.topics.retrieveAllUploadedFilesForTopicSuccess
    ) {
      this.setState(
        {
          allUploadedFilesForTopic: nextProps.topics.allUploadedFilesForTopic
        }, () => {
          this.setState({
            modalState: EDIT_TOPIC_MODAL_STATE
          }, () => {
            this.setState({
              isAddTopic: true
            });
          });
        }
      );
      this.props.actions.resetTopicState();
    }
  }

  _handlePropsForRetrieveAllUploadedFilesForTopicFailure(nextProps) {
    if (nextProps.topics.retrieveAllUploadedFilesForTopicFailure) {
      this.setState(
        {
          allUploadedFilesForTopic: {}
        }, () => {
          this.setState({
            modalState: EDIT_TOPIC_MODAL_STATE
          }, () => {
            this.setState({
              isAddTopic: true
            });
          }
        );
        }
      );
      toast.error(this.getI18nText(MY_I18N_KEYS.retrieve_uploaded_files_failure_toast_msg));
      this.props.actions.resetTopicState();
    }
  }

  onBlurForSearchInput = e => {
    const filterText = e.target.value;
    this._filterTopics({filterText: filterText, keepCurrentPage: false});
  }

  _filterTopics = ({filterText,keepCurrentPage}) => {
    this.setState({filterText: filterText});
    const { allTopicsData } = this.state;
    const filteredTopicsData = (filterText.trim() == "") ? allTopicsData : allTopicsData.filter(this._topicContainsString);
    this.setState({
      filteredTopicsData: filteredTopicsData,
      totalPage: Math.ceil(filteredTopicsData.length / this.state.pageLimit) || 1,
    }, () => {
      if (keepCurrentPage) {
        this.handlePagination("same");
      }
      else {
        this.handlePagination("reset");
      }
    });
  }

  _topicContainsString = topic => {
    const {filterText} = this.state;
    const lcFilterText = filterText.toLowerCase();
    let containsFilterText = false;
    try {
      if (topic.topicName.toLowerCase().includes(lcFilterText)) {
        return true;
      }
    }
    catch (err) {}
    try {
      if (topic.description.toLowerCase().includes(lcFilterText)) {
        return true;
      }
    }
    catch (err) {}
    topic.categories.forEach(function(category){
      if (category.toLowerCase().includes(lcFilterText)) {
        containsFilterText = true;
      }
    });
    if (topic.keywordsJSON) {
      topic.keywordsJSON[BOOLEAN_AND].forEach(function(keywordJSONSection){
        if (Object.keys(keywordJSONSection).length > 0) {
          const booleanOperator = Object.keys(keywordJSONSection)[0];
          keywordJSONSection[booleanOperator].forEach(function(keyword) {
            if (keyword.toLowerCase().includes(lcFilterText)) {
              containsFilterText = true;
            }
          });
        }
      });
    }
    return containsFilterText;
  }

  _generateStatusDisplayTextForTopic = topic => {
    if (topic.topicProcessedState === "ready") {
      if (topic.isEditable === true) {
        return "Ready";
      }
      else {
        return "Ready (Read-only)";
      }
    }
    else {
      return "Processing. Will be ready by " + topic.whenTopicProcessedStateIsReady;
    }
  }

  _convertKeywordsJSONToHumanReadableKeywords = topic => {
    let topicKeywordsString = "";
    if (topic.keywordsJSON === null) return this.getI18nText(MY_I18N_KEYS.no_topic_keywords_string);
    for (let i=0; i< topic.keywordsJSON[BOOLEAN_AND].length;i++) {
      if (topic.keywordsJSON[BOOLEAN_AND][i].hasOwnProperty(BOOLEAN_OR)) {
        if (i !== 0) {
          topicKeywordsString += " AND ";
        }

        topicKeywordsString += "(" + topic.keywordsJSON[BOOLEAN_AND][i][BOOLEAN_OR].join(" OR ") + ")";
      }
      else if (topic.keywordsJSON[BOOLEAN_AND][i].hasOwnProperty(BOOLEAN_NOT)) {
        if (topic.keywordsJSON[BOOLEAN_AND][i][BOOLEAN_NOT].length > 0) {
          topicKeywordsString += " AND NOT ";
        }
        topicKeywordsString += " " + topic.keywordsJSON[BOOLEAN_AND][i][BOOLEAN_NOT].join(" AND NOT ");
      }
    }

    return topicKeywordsString;
  }

  changeCreateOrEditModalState(newModalState) {
    let currentModalState = this.state.modalState;
    if (currentModalState !== newModalState){
      this.setState({
        modalState: newModalState
      });
    }
  }

  changeAddTopicActionType(newActionType) {
    let currentActionType = this.state.addTopicActionType;
    if (currentActionType !== newActionType){
      this.setState({
        addTopicActionType: newActionType
      });
    }
  }

  handleFileValidation(uploadedFileName) {
    this.setState({
      modalState: LOADING_MODAL_STATE,
      uploadedFileName: uploadedFileName
    });
  }

  handleFileUpload({fileInfoAfterValidation, fileValidationErrors, parsedData, totalDataPoints}) {
    if (!parsedData) {
      return;
    }
    const cleanedFileData = parsedData.filter(row => !row.hasError);

    this.setState(
      {
        fileInfoAfterValidation: fileInfoAfterValidation,
        fileValidationErrors: fileValidationErrors,
        cleanedFileData: cleanedFileData,
        totalDataPointsForUploadedFile: totalDataPoints,
        fileUploadDateTime: moment().format(DATE_TIME_IN_YYYY_MM_DD_HH_MM_SS_FORMAT),
      },
      () => {
        if (fileValidationErrors.length > 0) {
          this.setState({
            modalState: DATA_SUMMARY_WITH_ERRORS_MODAL_STATE
          });
        } else {
          this.setState({
            modalState: DATA_SUMMARY_MODAL_STATE
          });
        }
      }
    );
  }

  handleRemoveRowsWithErrors() {
    const hasCheckedDoNotShowRemoveRowsConfirmation = localStorage.getItem(LOCAL_STORAGE_KEY_FOR_DO_NOT_SHOW_REMOVE_ROWS_CONFIRMATION);

    if (hasCheckedDoNotShowRemoveRowsConfirmation) {
      this.setState(
        { 
          modalState: DATA_SUMMARY_MODAL_STATE
        }
      );
    } else {
      this.setState(
        { 
          modalState: REMOVE_ROWS_WITH_ERRORS_CONFIRMATION_STATE
        }
      );
    }
  }

  handleRemoveRowsWithErrorsCancellation() {
    this.setState(
      {
        modalState: DATA_SUMMARY_WITH_ERRORS_MODAL_STATE
      }
    );
  }

  handleRemoveRowsWithErrorsConfirmation() {
    const { cleanedFileData } = this.state;
    if (!cleanedFileData) {
      return;
    }
    this.setState({
      totalDataPointsForUploadedFile: cleanedFileData.length,
      modalState: DATA_SUMMARY_MODAL_STATE
    });
  }

  clearUploadedFileAndReturnToUploadFilesOrEditTopicModal() {
    this.setState({
      uploadedFileName: "",
      fileInfoAfterValidation: null,
      fileValidationErrors: [],
      cleanedFileData: null,
      totalDataPointsForUploadedFile: null,
      fileUploadDateTime: "",
      userInputDateForUploadedComments: null,
      userInputLanguageForUploadedComments: null
    });
    const { addTopicActionType } = this.state;
    if (addTopicActionType === ADD_NEW_UPLOAD_DATA_TOPIC_ACTION_TYPE) {
      this.changeCreateOrEditModalState(UPLOAD_FILES_MODAL_STATE);
    }
    else {
      this.changeCreateOrEditModalState(EDIT_TOPIC_MODAL_STATE);
    }
  }

  handleFinishUploadDataTopicCreation() {
    if (this.state.allUploadedData.length === 0) {
      this.handleCancelTopicCreationConfirmationModal();
    } 
    else {
      this.props.actions.resetTopicState();
      this.setState({
        isAddTopic: false, 
        newUploadDataTopicData: {},
        allUploadedData: []
      }, () => {
        this.props.actions.retrieveTopics({ pageId: 1, pageLimit: this.state.retrieveLimit });
      });
    } 
  }

  handleUserInputDateForUploadedComments(inputDate) {
    this.setState({
      userInputDateForUploadedComments: inputDate
    });
  }
  
  handleUserInputLanguageForUploadedComments(inputLanguage) {
    this.setState({
      userInputLanguageForUploadedComments: inputLanguage
    });
  }

  handleCancelTopicCreationConfirmationModal = () => {
    this.setState({
      previousModalState: this.state.modalState,
      modalState: CONFIRM_CANCEL_TOPIC_CREATION_STATE
    });
  };

  handleReturnBackToPreviousModalFromCancelTopicCreationModal = () => {
    this.setState({
      modalState: this.state.previousModalState,
      previousModalState: ""
    });
  }

  handleUploadedFileTopicCreationCancellation = () => {
    this.props.actions.resetTopicState();
    const { newUploadDataTopicData } = this.state;
    this.setState({ topicToDelete: newUploadDataTopicData }, () => {
      this.deleteTopic();
    });
  }

  postUploadedFile(){
    const { uploadFile } = this.props.actions;
    const { 
      cleanedFileData, 
      newUploadDataTopicData, 
      fileUploadDateTime,
      userInputDateForUploadedComments,
      userInputLanguageForUploadedComments,
      fileInfoAfterValidation,
      addTopicActionType,
      editTopicData
    } = this.state;
    const filteredData = this.getRelevantColumnsData(cleanedFileData);
    let uploadFileObject = this.convertParsedDataToObject(filteredData);

    let props = {};
    if (addTopicActionType === ADD_NEW_UPLOAD_DATA_TOPIC_ACTION_TYPE) {
      props[KEY_FOR_TOPIC_ID] = newUploadDataTopicData[KEY_FOR_TOPIC_ID];
    }
    else {
      props[KEY_FOR_TOPIC_ID] = editTopicData[KEY_FOR_TOPIC_ID];
    }
    props[KEY_FOR_UPLOADED_FILE] = uploadFileObject;
    props[KEY_FOR_FILE_DATE_UPLOADED] = fileUploadDateTime;
    if (userInputDateForUploadedComments) {
      props[KEY_FOR_DATE_FOR_COMMENTS] = userInputDateForUploadedComments;
    }
    props[KEY_FOR_FILE_LANGUAGE] = userInputLanguageForUploadedComments;
    uploadFile(props);

    const uplodedFileDetails = {
      fileName: fileInfoAfterValidation.name,
      size: fileInfoAfterValidation.size,
      language: userInputLanguageForUploadedComments,
      dateUploaded: fileUploadDateTime,
      status: DEFAULT_PROCESSED_STATUS
    };
    this.setState({
      uploadedFileBeingPostedToBackend: uplodedFileDetails
    });
  }

  getRelevantColumnsData(cleanedFileData) {
    const { fileInfoAfterValidation } = this.state;
    const availableColumns = Object.keys(cleanedFileData[0] || {});
    const relevantColumns = [CONTENT_KEY, DATE_KEY, SOURCE_KEY, SOURCE_LINK_KEY];
  
    return cleanedFileData.map(row => 
      this.filterRowByRelevantColumns(row, availableColumns, relevantColumns, fileInfoAfterValidation)
    );
  }

  filterRowByRelevantColumns(row, availableColumns, relevantColumns, fileInfoAfterValidation) {
    let filteredRow = {};
  
    relevantColumns.forEach(column => {
      if (availableColumns.includes(column)) {
        filteredRow[column] = row[column];
      } else if (column === SOURCE_KEY && !availableColumns.includes(SOURCE_KEY)) {
        filteredRow[SOURCE_KEY] = fileInfoAfterValidation.name;
      }
    });
  
    return filteredRow;
  }

  convertParsedDataToObject(filteredData) {
    const { fileInfoAfterValidation } = this.state;
    const csv = Papa.unparse(filteredData);
    const blob = new Blob([csv], { type: UPLOAD_FILE_IN_CSV_FORMAT });
    const file = new File([blob], fileInfoAfterValidation.name, { type: UPLOAD_FILE_IN_CSV_FORMAT });

    return file;
  }

  render() {
    const {
      isAddTopic,
      confirmDeleteModal,
      topicToDelete,
      filteredTopicsData,
      paginatedAndFilteredTopicsData,
      allCategories,
      allTopicNames,
      addTopicActionType,
      editTopicData,
      newUploadDataTopicData,
      modalState,
      fileInfoAfterValidation,
      fileValidationErrors,
      uploadedFileName,
      cleanedFileData,
      totalDataPointsForUploadedFile,
      allUploadedData,
      allUploadedFilesForTopic
    } = this.state;
    const {
      deleteTopicBegin,
      retrieveTopicsBegin,
      createTopicsSuccess,
      createTopicsBegin,
      updateTopicsBegin,
      topicPreviewPosts,
      topicPreviewTotalPostsCount,
      topicPreviewTotalCommentsCount,
      topicPreviewEstimatedProcessingTimeInHours,
      retrieveTopicPreviewBegin,
      retrieveTopicPreviewSuccess,
      retrieveTopicPreviewFailure
    } = this.props.topics;

    return (
      <div className="topics-container">
        <div className="topics">
          <div className="topics-header">
            {<Button
              label="Create Topic"
              icon="plus"
              onClick={() => this.showAddTopic()}
            />}
            <div style={{width: '200px'}}></div>
            <div className="pagination">
            <div className="search-container">
              <DebounceInput
                  minLength={0}
                  onBlur={this.onBlurForSearchInput}
                  onChange={this.onBlurForSearchInput}
                  placeholder="Search"
              />
              <i className="la la-search" />
            </div>
              <this.PaginationControl />
            </div>
          </div>

          <div className="topic-table">
            {retrieveTopicsBegin && <Loader />}
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>{this.getI18nText(MY_I18N_KEYS.topic_name)}</th>
                  <th>{this.getI18nText(MY_I18N_KEYS.description)}</th>
                  <th>{this.getI18nText(MY_I18N_KEYS.topic_keywords)}</th>
                  <th>{this.getI18nText(MY_I18N_KEYS.categories)}</th>
                  <th>{this.getI18nText(MY_I18N_KEYS.earliest_historical_data_date)}</th>
                  <th>{this.getI18nText(MY_I18N_KEYS.status)}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {paginatedAndFilteredTopicsData.length > 0 &&
                  paginatedAndFilteredTopicsData.map((topic, index) => (
                    <tr key={topic.topicId}>
                      <td>{topic.topicName}</td>
                      <td>{topic.description}</td>
                      <td>{this._convertKeywordsJSONToHumanReadableKeywords(topic)}</td>
                      <td>{topic.categories.join(', ')}</td>
                      <td>{topic.earliestHistoricalDataDate}</td>
                      <td>
                        {this._generateStatusDisplayTextForTopic(topic)}
                      </td>
                      {! topic.isEditable ? (
                        <td>
                          <button className="btn edit-disabled"
                                  disabled={true}
                                  title="This topic cannot be edited because it contains additional data which cannot be re-collected automatically."
                          >
                            Edit
                          </button>
                          <button className="btn delete-disabled"
                                  disabled={true}
                                  title="This topic cannot be deleted because it contains additional data which cannot be re-collected automatically."
                          >
                            Delete
                          </button>
                        </td>
                      ) : topic.status ? (
                        <td>
                          <button className="btn edit-disabled"
                                  disabled={true}
                                  title="Cannot edit currently seleted topic."
                          >
                            Edit
                          </button>
                          <button className="btn delete-disabled"
                                  disabled={true}
                                  title="Cannot delete currently selected topic."
                          >
                            Delete
                          </button> &nbsp;
                          <small>*Select another topic from the topic dropdown to edit or delete this topic.</small>   
                        </td>
                      ) : (
                        <td>
                          <button className="btn edit" onClick={() => this.editTopic(topic)}>
                            Edit
                          </button>
                          <button className="btn delete" onClick={() => this.removeTopic(topic)}>
                            Delete
                          </button>
                      </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
            {!filteredTopicsData.length && !retrieveTopicsBegin && (
              <NoTopic
                title="Almost There"
                message="Create a category or topic, and start analysing the sentiments and emotions."
                icons={['area-chart', 'pie-chart', 'bar-chart']}
              >
                <button className="btn-add-topic" onClick={() => this.showAddTopic()}>
                  CREATE CATEGORY OR TOPIC
                </button>
              </NoTopic>
            )}
          </div>

          <div className="table-footer">
            <div className="pagination">
              <this.PaginationControl />
            </div>
          </div>
        </div>
        {isAddTopic && (
          <CreateTopicModalManager
            show={isAddTopic}
            toggleModal={this.toggleModal}
            modalState={modalState}
            type={addTopicActionType}
            createTopics={e => this.addEditModalAction(e)}
            retrieveTopicPreview={e => this.retrieveTopicPreviewAction(e)}
            topicData={editTopicData}
            newUploadDataTopicData={newUploadDataTopicData}
            allCategories={allCategories}
            resetAddTopicForm={createTopicsSuccess}
            createTopicsBeginStatus={createTopicsBegin}
            updateTopicsBegin={updateTopicsBegin}
            allTopicNames={allTopicNames}
            topicPreviewPosts={topicPreviewPosts}
            topicPreviewTotalPostsCount={topicPreviewTotalPostsCount}
            topicPreviewTotalCommentsCount={topicPreviewTotalCommentsCount}
            topicPreviewEstimatedProcessingTimeInHours={topicPreviewEstimatedProcessingTimeInHours}
            retrieveTopicPreviewBegin={retrieveTopicPreviewBegin}
            retrieveTopicPreviewSuccess={retrieveTopicPreviewSuccess}
            retrieveTopicPreviewFailure={retrieveTopicPreviewFailure}
            changeModalState={e => this.changeCreateOrEditModalState(e)}
            changeAddTopicActionType={e => this.changeAddTopicActionType(e)}
            handleFileValidation={e => this.handleFileValidation(e)}
            handleFileUpload={e => this.handleFileUpload(e)}
            handleRemoveRowsWithErrors={() => this.handleRemoveRowsWithErrors()}
            clearUploadedFileAndReturnToUploadFilesOrEditTopicModal={() => this.clearUploadedFileAndReturnToUploadFilesOrEditTopicModal()}
            handleFinishUploadDataTopicCreation={() => this.handleFinishUploadDataTopicCreation()}
            postUploadedFile={() => this.postUploadedFile()}
            fileInfoAfterValidation={fileInfoAfterValidation}
            fileValidationErrors={fileValidationErrors}
            uploadedFileName={uploadedFileName}
            handleRemoveRowsWithErrorsConfirmation={() => this.handleRemoveRowsWithErrorsConfirmation()}
            handleRemoveRowsWithErrorsCancellation={() => this.handleRemoveRowsWithErrorsCancellation()}
            cleanedFileData={cleanedFileData}
            totalDataPointsForUploadedFile={totalDataPointsForUploadedFile}
            handleUserInputDateForUploadedComments={e => this.handleUserInputDateForUploadedComments(e)}
            handleUserInputLanguageForUploadedComments={e => this.handleUserInputLanguageForUploadedComments(e)}
            handleReturnBackToPreviousModalFromCancelTopicCreationModal={() => this.handleReturnBackToPreviousModalFromCancelTopicCreationModal()}
            handleUploadedFileTopicCreationCancellation={() => this.handleUploadedFileTopicCreationCancellation()}
            allUploadedData={allUploadedData}
            allUploadedFilesForTopic={allUploadedFilesForTopic}
          />
        )}
        {confirmDeleteModal && (
          <DeleteConfirmation
            show={confirmDeleteModal}
            title="Delete Category or Topic"
            disabled={deleteTopicBegin}
            message={
              topicToDelete != null
                ? `You are deleting <strong>'${topicToDelete.topicName}'</strong>. This action cannot be undone. Proceed?`
                : ''
            }
            toggleModal={()=>{
              window.history.replaceState(this.state,'','/dashboard/topics')
              this.setState({ confirmDeleteModal: false });}}
            confirmDelete={() => this.deleteTopic()}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    topics: state.topics,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, updateTopicDropdownOnAddTopic,retrieveTopicsDropdown }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Topics);




// WEBPACK FOOTER //
// ./src/features/topics/Topics.js